import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {InvoiceDetailsPage} from '../../../invoices/invoice-details-page'

export const Route = createFileRoute('/_app/invoices/$invoiceId')({
    component: InvoiceDetailsRoute,
})

function InvoiceDetailsRoute() {
    const {invoiceId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <InvoiceDetailsPage invoiceId={invoiceId} />
        </Container>
    )
}
